import React, { Component } from 'react'
import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem, PreviewItem } from '../../../../common/MyPATUploadPreview';

//@ts-ignore
interface OrderNotesProps extends WithStyles<typeof styles> {
    classes: any,
    firstName: string,
    orderNote: any,
    lastName: string,
    orderNoteAttachments: string[]
}



interface OrderNotesStates {
    attachmentPreviewList: PreviewItem[];
}

export default class TestDetailsOrder extends Component<OrderNotesProps, OrderNotesStates> {

    state: OrderNotesStates = {
        attachmentPreviewList: []
    }

    componentDidMount() {
        if(this.props.orderNoteAttachments) {
          this.setState({
            attachmentPreviewList: this.props.orderNoteAttachments.map(attachment => convertFileOrUrlToPreviewItem(attachment))
          })
        }
      }
    

    render() {
        const { classes, firstName ,orderNote, lastName } = this.props;
        const { attachmentPreviewList } = this.state;
        return (
            <div>
                <Grid className={classes.customCard}>
                    <Grid container style = {{ marginBottom : '8px' }} justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography className={classes.orderNotes}>
                                ORDER NOTES
                        </Typography>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.subjectName}>
                                By: <span> {firstName}{' '}{lastName} </span>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid spacing={8} container>
                        <Grid item className={classes.maxHeight4}>
                            <PerfectScrollbar>
                            <Typography dangerouslySetInnerHTML={{ __html: orderNote }} ></Typography>
                            </PerfectScrollbar>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.marginTop}>
                        <MyPATUploadPreview list={attachmentPreviewList} itemsDownloadable />
                    </Grid>
                </Grid>
            </div>
        )
    }
}
